/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SVGIcon } from "@nordcloud/gnui";
import { ArrowWrap, BoxWrap, DropdownWrapStyle, ShowDropDown } from "../../styles";
import { FlexContainer } from "./styles";
import { UserDropdown } from "./UserDropdown";

type DropdownWrapProps = {
  children?: React.ReactNode;
  userName: string;
};

export function DropdownWrap({ children, userName }: DropdownWrapProps) {
  return (
    <DropdownWrapStyle>
      <BoxWrap>
        <FlexContainer>
          {children}
          <ArrowWrap>
            <SVGIcon name="down" />
          </ArrowWrap>
        </FlexContainer>
        <ShowDropDown>
          <UserDropdown userName={userName} />
        </ShowDropDown>
      </BoxWrap>
    </DropdownWrapStyle>
  );
}
